export interface SizeQuantities {
  P: number;
  M: number;
  G: number;
  GG: number;
  EGG: number;
  U: number;
}

export const SIZES = ['P', 'M', 'G', 'GG', 'EGG', 'U'] as const;
export type Size = typeof SIZES[number];

export const SIZE_LABELS: Record<Size, string> = {
  P: 'P',
  M: 'M 44',
  G: 'G 46',
  GG: 'GG 48',
  EGG: 'EGG 50',
  U: 'U',
};

export interface StockCategory {
  id: string;
  organization_id: string;
  name: string;
  description: string | null;
  display_order: number;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface StockSupplier {
  id: string;
  organization_id: string;
  name: string;
  cnpj: string | null;
  phone: string | null;
  email: string | null;
  address: string | null;
  contact_person: string | null;
  notes: string | null;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface StockProduct {
  id: string;
  organization_id: string;
  category_id: string | null;
  supplier_id: string | null;
  name: string;
  code: string | null;
  sku: string | null;
  description: string | null;
  unit: string;
  current_quantity: number;
  minimum_quantity: number;
  cost_price: number;
  sale_price: number | null;
  location: string | null;
  size_quantities: SizeQuantities;
  is_active: boolean;
  created_at: string;
  updated_at: string;
  // Joined fields
  category?: StockCategory;
  supplier?: StockSupplier;
}

export interface StockMovement {
  id: string;
  organization_id: string;
  product_id: string;
  user_id: string;
  type: 'entry' | 'exit' | 'adjustment';
  quantity: number;
  size: Size;
  unit_cost: number | null;
  total_cost: number | null;
  reason: string | null;
  reference_type: string | null;
  reference_id: string | null;
  notes: string | null;
  created_at: string;
  // Joined fields
  product?: StockProduct;
}

export interface StockStats {
  totalProducts: number;
  totalValue: number;
  lowStockCount: number;
  outOfStockCount: number;
}

// Helper to calculate total from size quantities
export function calculateTotalFromSizes(sizeQuantities: SizeQuantities | null): number {
  if (!sizeQuantities) return 0;
  return Object.values(sizeQuantities).reduce((sum, qty) => sum + (qty || 0), 0);
}

// Helper to get default size quantities
export function getDefaultSizeQuantities(): SizeQuantities {
  return { P: 0, M: 0, G: 0, GG: 0, EGG: 0, U: 0 };
}
